import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=2780d55f"
import script from "./SingleFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports